
<div class="container">
  <div class="text-center">
    <h2 class="headline">{{langSafe('Deine Daten wurden gelöscht!', 'Your data has been deleted!')}}</h2>
  </div>
  <div class="row text-center">
    <div class="col-sm-12" [innerHTML]="langSafe('Vielen Dank, dass du Leada genutzt hast und wir freuen uns, wenn du uns noch ein Feedback schenkst,
      wie wir uns weiter verbessern können <a href=\'\'mailto:info@leada.de?subject=About Leada\'\' class=\'\'mail\'\'>info@leada.de</a>.<br/>Alles Gute und weiterhin viel Erfolg!',
      'Thank you for using Leada and we will be happy if you give us some feedback on how we can
      improve our service <a href=\'\'mailto:info@leada.de?subject=About Leada\'\' class=\'\'mail\'\'>info@leada.de</a>.<br/>All the best!', true)">
    </div>
  </div>
</div>
